module.exports = {
	totalWard: 14,
	palikaName: "फिदिम"
};
